import React, { useRef } from "react";

const readFileAsDataUrl = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

const AdminImageUpload = ({
  value,
  onChange,
  multiple = false,
  accept = "image/*",
  buttonLabel = "Upload image",
}) => {
  const inputRef = useRef(null);

  const handlePick = async (event) => {
    const files = Array.from(event.target.files || []);
    if (!files.length) return;

    const dataUrls = await Promise.all(files.map(readFileAsDataUrl));

    if (multiple) {
      const existing = String(value ?? "")
        .split("\n")
        .map((line) => line.trim())
        .filter(Boolean);
      onChange([...existing, ...dataUrls].join("\n"));
    } else {
      onChange(dataUrls[0]);
    }

    event.target.value = "";
  };

  return (
    <div className="admin-image-upload">
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        multiple={multiple}
        className="admin-image-upload__input"
        onChange={handlePick}
      />
      <button
        type="button"
        className="admin-image-upload__btn"
        onClick={() => inputRef.current?.click()}
      >
        {multiple ? "Upload photos" : buttonLabel}
      </button>
      <span className="admin-image-upload__hint">
        {multiple ? "Adds photos below — one URL per line" : "Or paste an image URL above"}
      </span>
    </div>
  );
};

export default AdminImageUpload;
